import { useState } from 'react';
import { downloadExport } from '../api/campaign.js';
import { apiFetch, getCampaignId } from '../api/client.js';
import ExportFilters from './ExportFilters.jsx';

/**
 * Export buttons panel with CSV, Excel, PDF, and email export options.
 * Includes date range, status, and driver filter controls.
 */
export default function ExportButtons() {
  const [downloading, setDownloading] = useState('');
  const [filters, setFilters] = useState({});
  const [emailStatus, setEmailStatus] = useState('');

  /** @param {string} path @param {string} filename */
  const handleExport = (path, filename) => {
    setDownloading(path);
    downloadExport(path, filename, filters);
    setTimeout(() => setDownloading(''), 2000);
  };

  const handleEmailExport = async () => {
    setEmailStatus('sending');
    try {
      const cid = getCampaignId();
      const result = await apiFetch(`/c/${cid}/export/email`, {
        method: 'POST',
        body: JSON.stringify({}),
      });
      setEmailStatus(result.mode === 'simulation' ? 'saved' : 'sent');
      setTimeout(() => setEmailStatus(''), 3000);
    } catch (_err) {
      setEmailStatus('error');
      setTimeout(() => setEmailStatus(''), 3000);
    }
  };

  return (
    <div className="bg-white rounded-xl p-6 shadow-sm space-y-4">
      <h3 className="font-semibold">Exports</h3>

      <ExportFilters filters={filters} onChange={setFilters} />

      <div className="grid grid-cols-2 gap-3">
        <ExportBtn
          label="CSV clients"
          active={downloading === 'clients.csv'}
          onClick={() => handleExport('clients.csv', 'clients.csv')}
          color="blue"
        />
        <ExportBtn
          label="CSV livraisons"
          active={downloading === 'deliveries.csv'}
          onClick={() => handleExport('deliveries.csv', 'livraisons.csv')}
          color="blue"
        />
        <ExportBtn
          label="Excel clients"
          active={downloading === 'clients.xlsx'}
          onClick={() => handleExport('clients.xlsx', 'clients.xlsx')}
          color="green"
        />
        <ExportBtn
          label="PDF campagne"
          active={downloading === 'campaign-report.pdf'}
          onClick={() => handleExport('campaign-report.pdf', 'rapport-campagne.pdf')}
          color="green"
        />
      </div>

      <div className="border-t pt-3">
        <button
          onClick={handleEmailExport}
          disabled={emailStatus === 'sending'}
          className="w-full bg-gray-700 hover:bg-gray-800 text-white py-3 rounded-lg font-medium text-sm disabled:opacity-50"
        >
          {emailStatus === 'sending' ? 'Génération...' : emailStatus === 'saved' ? 'Fichier sauvegardé sur le serveur' : emailStatus === 'error' ? 'Erreur' : 'Exporter par email (simulation)'}
        </button>
      </div>

      <p className="text-xs text-gray-400 mt-2">
        Les PDF (bon de livraison, rapport tournée) sont aussi accessibles depuis la fiche client et le détail de tournée.
      </p>
    </div>
  );
}

/**
 * Single export button component.
 * @param {{ label: string, active: boolean, onClick: () => void, color: string }} props
 */
function ExportBtn({ label, active, onClick, color }) {
  const colors = {
    blue: 'bg-blue-600 hover:bg-blue-700',
    green: 'bg-green-600 hover:bg-green-700',
  };

  return (
    <button
      onClick={onClick}
      disabled={active}
      className={`${colors[color] || colors.blue} text-white py-3 rounded-lg font-medium text-sm disabled:opacity-50`}
    >
      {active ? 'Téléchargement...' : label}
    </button>
  );
}
